import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const axiosInstanceWithoutAuth = Axios.create({
  baseURL:
    process.env.REACT_APP_CRM_API_HOST ?? 'https://crm-api-dev.frism.io/',
  timeout: 60 * 1000,
});

/* NOTE: kunhee.lim
 *  codegen 에서 사용하는 customAxios 외에 나머지 api 호출은 이 함수를 사용할것 */
export const customAxiosWithoutAuth = async <T>(
  config: AxiosRequestConfig,
): Promise<AxiosResponse<T>> => {
  const method = config.method ?? 'GET';
  const url = config.url;

  console.log(method, url);

  if (!config.headers) {
    config.headers = {};
  }

  const response: AxiosResponse<T> = await axiosInstanceWithoutAuth(config);
  return response;
};
